import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesEditResponseType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApisAdminOperatorsCompaniesEditResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesEditResponseType>(
      `/api/admin_operators/companies/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsCompaniesEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApisAdminOperatorsCompaniesEditResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAdminOperatorsCompaniesEdit", id],
    queryFn: () => request({ id }),
  });
};
